export default __webpack_public_path__ + "static/media/totalsArrowsRotate.5c2dea35.gif";